/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum DxpSubscriptionSize {
  bespoke = 'bespoke',
  lite = 'lite',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum DxpSubscriptionPlatform {
  contentManagement = 'dxp-content-management',
  dataServices = 'dxp-data-services',
  integrations = 'dxp-integrations',
  search = 'dxp-search',
  unknown = 'dxp-unknown',
}

export enum DxpSubscriptionModel {
  evaluation = 'evaluation',
  overage = 'overage',
  sized = 'sized',
}
